import { Div2Floor } from "../utils/Div2Floor";
import {
  enumButtonIconPosition,
  enumButtonLabelPosition,
  enumElementDrawStates,
  enumFontIconWeights,
  enumPadBorderType,
  kFramelessDropDownMarginH,
  kOCNDarkGrayColor
} from "../constants";
import { QElement } from "./QElement";
import { shadeColor } from "../utils/shadeColor";
import { SetCtxFont } from "../utils/SetCtxFont";
import { fontIconString } from "../utils/fontIconString";
import { MeasureTextHeight } from "../utils/MeasureTextHeight";
import { CenterIt } from "../utils/CenterIt";
import { MeasureText } from "../utils/MeasureText";

export class QButton extends QElement {
  constructor() {
    super();
    this.fRadioSelect = false;
    this.fRadioButton = false;

    // Label
    this.fLabel = "";
    this.fShowLabel = false;
    this.fLabelPosition = enumButtonLabelPosition.below;
    this.fPadBorderType = enumPadBorderType.fullBorder;
    this.fIconPosition = enumButtonIconPosition.left;

    // Toggle Button
    this.fToggleButton = false;
    this.fToggleOn = false;
    this.fLabel2 = null;
    //	this.fIconScaling = enumIconScaling.noScale;

    this.fTxtFillStyle = null;
    this.fIsActive = false;
    this.fIsHighlighted = false;
    this.fDrawPad = true;
    this.fFontString = "11px Verdana";
    this.fTextAlign = "center";
  }

  AutoSize() {
    // Size Button based on Label, Label Placement and Image
  }

  SetFontColor(fontColor) {
    this.fTxtFillStyle = fontColor;
  }

  GetFontIconStyle() {
    if (this.fFontIconStyle == null) {
      var fontIconSize = this.fFontString.split("px")[0].slice(-2);
      var fontIconWeight = enumFontIconWeights.regular;
      this.fFontIconStyle = fontIconString(parseInt(fontIconSize) + 1, fontIconWeight);
    }
    return this.fFontIconStyle;
  }

  GetFontIconLabelWidth() {
    if (this.fFontIconWidth == null) {
      this.fFontIconWidth = MeasureTextHeight(
        this.GetFontIconStyle(),
        this.GetFontSize(),
        this.fFontIcon
      );
    }
    return this.fFontIconWidth;
  }

  GetFontSize() {
    return this.fFontString.split("px")[0].slice(-2);
  }

  GetFontColor() {
    return this.fTxtFillStyle;
  }

  SetLabel(label) {
    this.fLabel = label;
  }

  GetLabel() {
    return this.fLabel;
  }

  SetDrawPad(drawPad) {
    this.fDrawPad = drawPad;
  }

  GetDrawPad() {
    return this.fDrawPad;
  }

  SetLabel2(label2) {
    this.fLabel2 = label2;
  }

  SetShowLabel(showLabel) {
    this.fShowLabel = showLabel;
  }

  // Radio Button
  SetIsRadioButton(radioButton) {
    this.fRadioButton = radioButton;
  }

  IsRadioButton() {
    return this.fRadioButton;
  }

  SetRadioSelect(radioSelect) {
    this.fRadioSelect = radioSelect;
  }

  GetRadioSelect() {
    return this.fRadioSelect;
  }

  // Toggle Button
  SetIsToggleButton(toggleButton) {
    this.fToggleButton = toggleButton;
  }

  IsToggleButton() {
    return this.fToggleButton;
  }

  SetCursor(cursorMode) {
    this.fCurCursor = cursorMode;
  }

  SetToggleState(toggleOn) {
    this.fToggleOn = toggleOn;
  }

  GetToggleState() {
    return this.fToggleOn;
  }

  DoHandleMouseUp() {
    if (this.IsToggleButton()) {
      this.fToggleOn = !this.fToggleOn;
    }
  }

  // Label Handling
  SetLabelPosition(labelPosition) {
    this.fLabelPosition = labelPosition;
  }

  GetLabelPosition() {
    return this.fLabelPosition;
  }

  MeasureLabel() {
    this.CreateMeasureBuffer();
    var ctx = this.fMeasureBuffer.getContext("2d");

    //ctx.font="11px Verdana";
    var fontStr = this.fFontString;
    if (fontStr == null) {
      //console.log('ruh roh - no fonts :(');
      fontStr = "11px Verdana";
    }
    SetCtxFont(ctx, fontStr);
    var txt = this.fLabel;
    var txtDim = ctx.measureText(txt);
    var txtWidth = Math.ceil(txtDim.width);

    return txtWidth;
  }

  DrawLabel(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    var txtFillStyle;

    switch (this.GetDrawState()) {
      case enumElementDrawStates.Std:
      case enumElementDrawStates.MouseDown:
      case enumElementDrawStates.Hover:
        txtFillStyle = "#111111";
        if (this.fTxtFillStyle != null) {
          txtFillStyle = this.fTxtFillStyle;
        }
        break;
      case enumElementDrawStates.Disabled:
        txtFillStyle = "#8D8D8D";
        break;
    }

    ctx.fillStyle = txtFillStyle;

    // Replace this with call to measure text
    //ctx.font="11px Verdana";
    var fontString = "11px Verdana";
    if (this.fFontString != null) {
      fontString = this.fFontString;
    }

    SetCtxFont(ctx, fontString);
    var txt = this.fLabel;
    //var txtDim = ctx.measureText(txt);
    //var txtHeight = txtDim.height;

    //var txtHOffset = (this.fWidth - txtWidth)/2; // Center
    //var txtHOffset = Math.floor(this.fWidth/2);
    var txtHOffset = Div2Floor(this.fWidth);
    //var txtVOffset = txtHeight/2;
    //var txtVOffset = this.fHeight - txtHeight;
    //var txtHeight = 12;
    var txtVOffset = 2;
    ctx.textAlign = this.fTextAlign;
    ctx.textBaseline = "bottom";

    var xPos, yPos;
    switch (this.fLabelPosition) {
      case enumButtonLabelPosition.below:
        xPos = this.fHorzOffset + txtHOffset;
        yPos = this.fVertOffset + this.fHeight - txtVOffset;
        break;
      case enumButtonLabelPosition.center:
        ctx.textBaseline = "middle";
        xPos = this.fHorzOffset + txtHOffset;
        yPos = this.fHeight / 2; // Center vertical
        yPos = this.fVertOffset + this.fHeight / 2;
        break;
      case enumButtonLabelPosition.left:
        var labelW = this.MeasureLabel();
        var txtHIndent = 6;
        ctx.textBaseline = "middle";
        xPos = this.fHorzOffset + labelW / 2 + txtHIndent + this.fLabelInset;
        yPos = this.fVertOffset + this.fHeight / 2;
        break;
    }

    ctx.fillText(txt, xPos, yPos);

    if (this.fLabel2 != null) {
      yPos += 6;
      ctx.fillText(this.fLabel2, xPos, yPos);
    }
  }

  SetPadBorderType(padBorderType) {
    this.fPadBorderType = padBorderType;
  }

  // standard selected, hover mode, hover selected, mousedown
  DrawPad(drawBuffer, mouseDown, selected, highlighted) {
    var ctx = drawBuffer.getContext("2d");
    ctx.save();

    var r2d = Math.PI / 180;
    var stdColor = kOCNDarkGrayColor;
    var darkColor = shadeColor(kOCNDarkGrayColor, -5);
    var highlightColor = shadeColor(kOCNDarkGrayColor, 50);
    ctx.strokeStyle = "#111111";
    ctx.lineWidth = 1;

    var r = 1;
    var sx = this.fHorzOffset - 1.5;
    var sy = this.fVertOffset + 0.5;
    var ex = this.fHorzOffset + this.fWidth + 1.5;
    var ey = this.fVertOffset + this.fHeight - 0.5;

    var bt = this.fPadBorderType;
    switch (bt) {
      case enumPadBorderType.fullBorder:
        ctx.beginPath();
        ctx.moveTo(sx + r, sy);
        ctx.lineTo(ex - r, sy);
        ctx.arc(ex - r, sy + r, r, r2d * 270, r2d * 360, false);
        ctx.lineTo(ex, ey - r);
        ctx.arc(ex - r, ey - r, r, r2d * 0, r2d * 90, false);
        ctx.lineTo(sx + r, ey);
        ctx.arc(sx + r, ey - r, r, r2d * 90, r2d * 180, false);
        ctx.lineTo(sx, sy + r);
        ctx.arc(sx + r, sy + r, r, r2d * 180, r2d * 270, false);
        ctx.closePath();
        //ctx.stroke();
        break;
      case enumPadBorderType.leftBorder:
        ctx.beginPath();
        ctx.moveTo(ex, sy);
        ctx.lineTo(sx + r, sy);
        ctx.arc(sx + r, sy + r, r, r2d * 270, r2d * 180, true);
        ctx.lineTo(sx, ey - r);
        ctx.arc(sx + r, ey - r, r, r2d * 180, r2d * 90, true);
        ctx.lineTo(ex, ey);
        //ctx.stroke();
        ctx.closePath();
        break;
      case enumPadBorderType.rightBorder:
        ctx.beginPath();
        ctx.moveTo(sx, sy);
        ctx.lineTo(ex - r, sy);
        ctx.arc(ex - r, sy + r, r, r2d * 270, r2d * 360, false);
        ctx.lineTo(ex, ey - r);
        ctx.arc(ex - r, ey - r, r, r2d * 0, r2d * 90, false);
        ctx.lineTo(sx, ey);
        //ctx.stroke();
        ctx.closePath();
        break;
      case enumPadBorderType.middleBorder:
        ctx.beginPath();
        ctx.moveTo(sx, sy);
        ctx.lineTo(ex, sy);
        //ctx.stroke();
        ctx.moveTo(sx, ey);
        ctx.lineTo(ex, ey);
        //ctx.stroke();
        ctx.lineTo(ex, sy);
        ctx.lineTo(sx, sy);
        ctx.closePath();
        break;
    }

    // Hover, Selected				-> dark gradient, indent
    // Hover, Not Selected			-> light gradient, no ident
    // Mousedown, Selected			-> dark gradient, indent
    // Mousedown, Not Selected		-> dark gradient, indent

    var gradient = ctx.createLinearGradient(0, sy, 0, ey); // this.fHeight
    if (mouseDown || selected) {
      // Dark gradient
      var fillColor = mouseDown ? darkColor : stdColor;
      gradient.addColorStop(0, fillColor);
      gradient.addColorStop(1, fillColor);
    } else if (highlighted) {
      // Lighter gradient
      gradient.addColorStop(0, highlightColor);
      gradient.addColorStop(1, highlightColor);
    } else {
      gradient.addColorStop(0, stdColor);
      gradient.addColorStop(1, stdColor);
    }

    ctx.fillStyle = gradient;
    ctx.globalAlpha = mouseDown || selected ? 0.3 : 0.2;

    if (this.GetDrawState() === enumElementDrawStates.Hover && selected) ctx.stroke();

    ctx.fill();

    ctx.restore();
  }

  DoingHoverDraw() {
    // Override this
  }

  GetCursor() {
    return "pointer";
  }

  DoRenderElement(drawBuffer) {
    var isToggleButton = this.IsToggleButton();
    var drawPad = this.fDrawPad;
    var drawAsSelected = false;
    var drawAsHighlighted = this.fIsHighlighted;
    if (this.IsRadioButton()) drawAsSelected = this.GetRadioSelect();
    else if (isToggleButton) drawAsSelected = this.GetToggleState();

    if (drawPad) {
      switch (this.GetDrawState()) {
        case enumElementDrawStates.Std:
          if (drawAsSelected || drawAsHighlighted)
            this.DrawPad(drawBuffer, false, drawAsSelected, drawAsHighlighted);
          break;
        case enumElementDrawStates.Hover:
          this.DoingHoverDraw();
          this.DrawPad(drawBuffer, false, drawAsSelected, true);
          break;
        case enumElementDrawStates.MouseDown:
          this.DrawPad(drawBuffer, true, drawAsSelected, drawAsHighlighted);
          break;
        case enumElementDrawStates.Disabled:
          break;
      }
    }

    this.DoRenderContent(drawBuffer);

    if (this.fShowLabel) this.DrawLabel(drawBuffer);
  }

  GenerateAdditionalCmdParameters() {
    if (this.IsToggleButton()) this.AddCmdParameter("ToggleState", this.GetToggleState());
  }

  DrawFontIcon(
    ctx,
    xPos,
    yPos,
    icon,
    availableWidth,
    buttonColor,
    iconAlignment,
    iconStyle,
    size,
    noColor
  ) {
    var faStyle = iconStyle ? iconStyle : this.GetFontIconStyle();
    var fontSize = size ? size : this.GetFontSize();

    ctx.save();
    ctx.textBaseline = "top";
    if (iconAlignment)
      ctx.textAlign = iconAlignment === enumButtonIconPosition.left ? "left" : "right";

    var iconX = xPos;
    var iconY = yPos + CenterIt(this.GetHeight(), MeasureTextHeight(faStyle, fontSize, icon));

    if (iconAlignment === enumButtonIconPosition.left) {
      iconX = CenterIt(availableWidth, MeasureText(icon, faStyle)) + (this.fIsActive ? 8 : 0); // need to account for current selection chiclet
    } else if (iconAlignment === enumButtonIconPosition.right) {
      iconX = xPos + this.GetWidth() - MeasureText(icon, faStyle) - kFramelessDropDownMarginH - 5;
    }

    SetCtxFont(ctx, faStyle);
    ctx.fillStyle = this.fIconColor ? this.fIconColor : buttonColor;
    if (noColor) ctx.fillStyle = buttonColor;
    ctx.fillText(icon, iconX, iconY);

    ctx.restore();
  }
}
